export enum Exchange {
  BINANCE = "binance",
  BYBIT = "bybit",
  KRAKEN = "kraken",
  CURRENCYLAYER = "currencylayer",
  YAHOO = "yahoo",
}
